module.exports = __webpack_public_path__ + "static/foot-db83e6e7d1b5d400e78e25fc04f460e3.png";